<template>
	<div>
		<v-combobox
			:items="[]"
			small-chips
			hide-selected
			:multiple="multiple"
			:rules="[...rules]"
			@change="onCardChange($event)"
			:hint="hint"
			type="number"
			:ref="param.name"
			:solo="solo"
			:class="{ dense_input: dense }"
			:value="value"
			:readonly="readonly"
			:disabled="disabled"
			:placeholder="placeholder ? 'Programme' : null"
			:append-icon="'search'"
			@click:append="explorer_show = true">
			<template v-slot:label>
				<span v-if="!param.hide_label">
					{{ param | maestroParamLabel }}
				</span>
			</template>
			<template v-slot:selection="{ item }">
				<span v-if="item">
					<v-chip
						v-if="labels[item] === 'loading'"
						label outline small
						class="input-chips"
						color="primary">
						<span class="label-id">
							{{ item }}
						</span>
						<v-progress-circular
							indeterminate
							color="background"
							:size="20"
							:width="2">
						</v-progress-circular>
					</v-chip>

					<v-chip
						v-else-if="labels[item]"
						label outline small
						class="input-chips"
						color="success lighten-1">
						<span class="pr-2" v-if="labels[item]">
							{{ labels[item] }}
						</span>
						<span class="label-id">
							{{ item }}
						</span>
						<span v-if="!disabled && !readonly">
							<v-icon
								v-if="multiple"
								small
								@click="removeCard(item)">
								close
							</v-icon>
							<v-icon
								v-else
								small
								@click="$emit('change', '')">
								close
							</v-icon>
						</span>
					</v-chip>

					<v-chip v-else label small class="input-chips" color="error">
						{{ item }}
						<span v-if="!disabled && !readonly">
							<v-icon
								v-if="multiple"
								small
								@click="removeCard(item)">
								close
							</v-icon>
							<v-icon
								v-else
								small
								@click="$emit('change', '')">
								close
							</v-icon>
						</span>
					</v-chip>
				</span>
			</template>
		</v-combobox>

		<Babel
			v-if="explorer_show"
			:multiselect="multiple"
			:toolbarTitle="param.name"
			:card_type="card_type"
			@close="explorer_show = false"
			@selected="onCardsSelected($event)">
			<h3 slot="header">Babel ID(s) Select for Maestro ingester</h3>
		</Babel>
	</div>
</template>

<script>
import Babel from '@/components/modal_babel.vue'
export default {
	props: [
		'value',
		'rules',
		'param',
		'hint',
		'readonly',
		'disabled',
		'solo',
		'dense',
		'placeholder',
		'card_type'
	],
	components: {
		Babel
	},
	data () {
		return {
			explorer_show: false,
			destination_key: null,
			labels: {}
		}
	},
	computed: {
		multiple () {
			return this.param.type === 'multi-babelid'
		}
	},
	watch: {
		value (val) {
			if (val) this.onCardChange(val)
		}
	},
	methods: {
		removeCard (id) {
			this.$emit('change', this.value.filter(item => item !== id))
		},

		onCardChange (values) {
			let valueToEmit = null
			let valueToLabel = null
			if (Array.isArray(values)) {
				if (values.at(-1)) valueToLabel = values.at(-1)
				let ids = values.map(id => {
					if (typeof (id) === 'string') {
						if (id.indexOf('ID non trouvée') > -1) return id
					}
					try {
						return parseInt(id)
					} catch (error) {
						return ''
					}
				})
				valueToEmit = ids.filter(id => {
					return id
				})
			} else {
				if (values) valueToLabel = values
				try {
					valueToEmit = parseInt(values)
				} catch (error) {
					valueToEmit = ''
				}
			}

			if (this.labels.hasOwnProperty(valueToLabel)) {
				this.$emit('change', valueToEmit)
				return
			}

			this.$set(this.labels, valueToLabel, 'loading')
			this.$EsMaestro.card_read(valueToLabel, {})
				.then(result => {
					let cardLabel = this.$maestro.babel_card_label(result)
					this.$set(this.labels, valueToLabel, cardLabel)
					this.$emit('change', valueToEmit)
				})
				.catch(error => {
					this.$delete(this.labels, valueToLabel)
					if (this.multiple) {
						let lastValue = valueToEmit.at(-1)
						lastValue = lastValue.toString() + ' ID non trouvée'
						valueToEmit[valueToEmit.length - 1] = lastValue
						this.$emit('change', valueToEmit)
					} else {
						this.$emit('change', valueToEmit + ' ID non trouvée')
					}
					console.error(error)
				})
		},

		async setLabels (ids) {
			let valueToEmit = []
			for (let id of ids) {
				this.$set(this.labels, id, 'loading')
				try {
					let result = await this.$EsMaestro.card_read(id, {})
					let cardLabel = this.$maestro.babel_card_label(result)
					this.$set(this.labels, id, cardLabel)
					valueToEmit.push(id)
				} catch (error) {
					delete this.labels[id]
					valueToEmit.push(id + ' ID non trouvée')
				}
			}
			if (this.multiple) {
				this.$emit('change', valueToEmit)
			} else {
				this.$emit('change', valueToEmit[0])
			}
		},

		onCardsSelected (evt) {
			let value = null
			if (this.multiple) {
				value = []
			} else {
				value = ''
			}
			evt.map(item => {
				if (this.multiple) {
					value.push(item.id)
				} else {
					value = item.id
				}
				let cardLabel = this.$maestro.babel_card_label(item)
				this.$set(this.labels, item.id, cardLabel)
			})
			this.$emit('change', value)
		}
	},
	mounted () {
		// On job duplicate need to load labels for validation
		this.$nextTick(() => {
			if (Array.isArray(this.value)) {
				this.setLabels(this.value)
			} else if (Number.isInteger(parseInt(this.value))) {
				this.setLabels([parseInt(this.value)])
			}
		})
	}
}
</script>

<style lang="stylus" scoped>
.input-chips
	margin-left: 0
	>>>.v-chip__content
		padding: 0 4px

>>>.v-select.v-select--is-menu-active
	.v-input__icon--append
		.v-icon
			-webkit-transform: none
			transform: none

.dense_input
	>>>.v-select__selections
		margin-left: 0 !important
		flex-wrap: nowrap
		.label-id
			padding: 0 4px 0 4px
			margin-right: 2px
			color: var(--v-color-base)
			font-weight: bold

.primary
	.label-id
		background-color: var(--v-primary-base)

.success
	.label-id
		background-color: var(--v-success-lighten1)

.error
	.label-id
		background-color: var(--v-error-base)

>>>input::-webkit-outer-spin-button
>>>input::-webkit-inner-spin-button
	-webkit-appearance: none
	margin: 0

>>>input[type=number]
	-moz-appearance: textfield
</style>



// WEBPACK FOOTER //
// src/components/field_babel_id.vue